import { Link } from "react-router-dom";
import { footerColumns } from "../contact";
import { GitHubIcon, LinkedInIcon, MailIcon } from "./Icons";

const connectIcons: Record<string, { Icon: typeof GitHubIcon; className: string }> = {
    LinkedIn: { Icon: LinkedInIcon, className: "footer-card__icon footer-card__icon--linkedin" },
    GitHub: { Icon: GitHubIcon, className: "footer-card__icon footer-card__icon--github" },
    "E-Mail": { Icon: MailIcon, className: "footer-card__icon footer-card__icon--email" },
};

export default function Footer() {
    return (
        <footer className="footer-card">
            <div className="footer-card__inner">
                <div className="footer-card__brand">
                    <span className="footer-card__name">Alexander Efremidis</span>
                    <span className="footer-card__role">Cloud Engineer</span>
                </div>

                <div className="footer-card__columns">
                    {footerColumns.map((column) => (
                        <div key={column.title} className="footer-card__column">
                            <h3 className="footer-card__title">{column.title}</h3>
                            <ul className="footer-card__list">
                                {column.links.map((link) => {
                                    const icon = connectIcons[link.label];
                                    const content = (
                                        <>
                                            {icon ? <icon.Icon className={icon.className} /> : null}
                                            <span>{link.label}</span>
                                        </>
                                    );
                                    return (
                                        <li key={link.label}>
                                            {link.external || link.href.startsWith("mailto:") || link.href.startsWith("/#") ? (
                                                <a
                                                    href={link.href}
                                                    target={link.external ? "_blank" : undefined}
                                                    rel={link.external ? "noopener noreferrer" : undefined}
                                                >
                                                    {content}
                                                </a>
                                            ) : (
                                                <Link to={link.href}>{content}</Link>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>

            <div className="footer-card__bottom">
                <span>
                    &copy; {new Date().getFullYear()} Efremidis. All rights reserved.
                </span>
            </div>
        </footer>
    );
}
